import { render, staticRenderFns } from "./FaltasAdministrativasComponent.vue?vue&type=template&id=d6689682"
import script from "./FaltasAdministrativasComponent.vue?vue&type=script&lang=js"
export * from "./FaltasAdministrativasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports